export const projects = [
  {
    slug: 'iblog',
    name: 'CodeCognition',
    label: 'PERSONAL PORTFOLIO & BLOG',
    labelZh: '个人作品集与博客',
    year: '2025',
    summary:
      'A full-stack personal publishing platform for documenting engineering work, managing articles and presenting finished projects.',
    summaryZh:
      '一个用于记录工程实践、管理技术文章和展示已完成项目的全栈个人发布平台。',
    overview:
      'You are viewing this project now. CodeCognition started as a compact personal blog and evolved into a portfolio and engineering notebook. It includes a React reading experience, a protected administration area and a Spring Boot API backed by MySQL.',
    overviewZh:
      '你现在正在浏览这个项目。CodeCognition 从一个简单的个人博客逐步发展为作品集和工程笔记，包含 React 阅读界面、受保护的管理后台，以及由 MySQL 支撑的 Spring Boot API。',
    technologies: ['React', 'Spring Boot', 'Spring Security', 'MyBatis', 'MySQL', 'Azure'],
    coverImage: null,
    screenshots: [],
    highlights: [
      'A focused React reading experience with rich-text article rendering and syntax highlighting.',
      'JWT-protected administration flows for creating, editing and publishing content.',
      'MyBatis persistence keeps SQL explicit and easy to inspect.',
      'Azure Pipelines provides a repeatable build and delivery path.',
    ],
    highlightsZh: [
      '提供专注的 React 阅读体验，支持富文本文章与代码高亮。',
      '使用 JWT 保护文章和项目的创建、编辑与发布流程。',
      '通过 MyBatis 保持 SQL 明确、透明且便于检查。',
      '使用 Azure Pipelines 建立可重复执行的构建与交付流程。',
    ],
    decisions: [
      {
        title: 'Keep the stack understandable',
        text: 'The application stays a conventional React and Spring Boot system so every layer can be inspected, tested and explained.',
      },
      {
        title: 'Portfolio before platform',
        text: 'The public experience prioritises projects, writing and personal context instead of growing into a complex CMS.',
      },
    ],
    decisionsZh: [
      {
        title: '保持技术栈清晰易懂',
        text: '应用保持传统的 React 与 Spring Boot 架构，让每一层都便于检查、测试和说明。',
      },
      {
        title: '作品展示优先',
        text: '公开页面优先呈现项目、文章和个人背景，不把网站扩张成复杂的内容管理平台。',
      },
    ],
    architecture: ['React SPA', 'REST API', 'Spring Security', 'Service Layer', 'MyBatis', 'MySQL'],
    architectureZh: ['React 单页应用', 'REST API', 'Spring Security', '服务层', 'MyBatis', 'MySQL'],
    accent: 'violet',
    githubUrl: null,
    demoUrl: 'https://code-cognition.com',
  },
];

export const localizeProject = (project, language = 'en') => {
  const useChinese = language.startsWith('zh') && project.summaryZh;
  if (!useChinese) return { ...project, contentLanguage: 'en' };
  return {
    ...project,
    label: project.labelZh || project.label,
    summary: project.summaryZh,
    overview: project.overviewZh || project.overview,
    highlights: project.highlightsZh?.length ? project.highlightsZh : project.highlights,
    decisions: project.decisionsZh?.length ? project.decisionsZh : project.decisions,
    architecture: project.architectureZh?.length ? project.architectureZh : project.architecture,
    contentLanguage: 'zh',
  };
};

export const getProjects = (language = 'en') =>
  projects.map((project) => localizeProject(project, language));

export const getProjectBySlug = (slug, language = 'en') => {
  const project = projects.find((item) => item.slug === slug);
  return project ? localizeProject(project, language) : undefined;
};
